import type { Column } from '@tanstack/react-table';
import type { CSSProperties } from 'react';
export function getColumnPinningStyle<TData>(column: Column<TData>): CSSProperties {
  const isPinned = column.getIsPinned();
  return {
    position: isPinned ? 'sticky' : 'relative',
    zIndex: isPinned ? 1 : undefined,
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined
  };
}

/**
 * pinnedカラムの影表示クラスを返す。
 * DataTableのコンテナ（`group/table-container`）が横スクロール中に
 * `data-scrolling="true"` になることを利用し、named group variantで影を出し分ける。
 */
export function getColumnPinningClassName<TData>(column: Column<TData>): string {
  if (!column.getIsPinned()) return '';
  return 'group-data-[scrolling=true]/table-container:shadow-md';
}